import {
    COUPON_LOADING, GET_COUPON_DATA_SUCCESS,
    GET_COUPON_DATA_ERROR, COUPON_END_LOADING, RESET_COUPON
} from "../actions/actionCoupon";

const initialState = {
    tourCoupon: {},
    loading: false,
    couponError: ''
};

function reducerCoupon(state = initialState, action) {

    switch (action.type) {
        case COUPON_LOADING: {
            return {
                ...state,
                loading: true,
                couponError: ''
            };
        }

        case GET_COUPON_DATA_SUCCESS: {

            return {
                ...state,
                loading: false,
                tourCoupon: action.payload,
                couponError: ''
            };
        }


        case GET_COUPON_DATA_ERROR: {
            return {
                ...state,
                loading: false,
                tourCoupon: {},
                couponError: action.error
            }
        }

        case COUPON_END_LOADING: {
            return {
                ...state,
                loading: false
            }
        }

        case RESET_COUPON: {
            return {
                ...state,
                tourCoupon: {},
                loading: false,
                couponError: ''
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerCoupon;